import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Formula extends BasicEntity {
code: string;
description: TranslatedEmb;
formula: string;
label: TranslatedEmb;
}

